import { Modal, Switch } from 'antd';
import { getFullName } from '@/utils';
import { useAddInquiryMutation } from '@/services/parent-api';
import Button from '@/components/button';
import { useState } from 'react';

const MessageModal = ({ parentId, open, selectedChild, isRec, refetch, onClose }) => {
  const [addInquiry, { isLoading: loadingSearch }] = useAddInquiryMutation();
  const [switchStates, setSwitchStates] = useState(
    [true, true, true, true], // Initialize all to true, or use specific values as needed
  );

  const handleChange = (checked, index) => {
    // Update the state of the specific switch
    const updatedSwitches = [...switchStates];
    updatedSwitches[index] = checked;
    setSwitchStates(updatedSwitches);
  };

  const onProcess = async () => {
    const inquirySubType = isRec ? 'meet-n-greet' : 'child-inquiry';
    let childrenIds = [selectedChild.child.childId];
    selectedChild.child.siblings.map((item) => childrenIds.push(item.childId));
    const tmpRecipients = selectedChild.recipients.map((item, index) => {
      if (!switchStates[index]) return { ...item, sendTo: false };
      return item;
    });
    const data = {
      childrenIds,
      date: new Date(),
      letterId: selectedChild.letterId,
      letterName: selectedChild.name,
      recipients: tmpRecipients,
    };
    await addInquiry({ parentId, data, inquirySubType }).unwrap();
    refetch();
    onClose();
  };

  const footerContent = (
    <>
      <Button onClick={onClose}>Cancel</Button>
      <Button type="primary" onClick={onProcess}>
        Process
      </Button>
    </>
  );

  return (
    <>
      <Modal
        title="ADD INQUIRY"
        open={!!open}
        cancelText="Close"
        onCancel={onClose}
        width={800}
        confirmLoading={loadingSearch}
        footer={footerContent}
      >
        {selectedChild && (
          <>
            <div style={{ fontSize: '25px' }}>
              <b>
                <span>{getFullName(selectedChild.child.name)}</span>
                <span>[{selectedChild.child.childCode}]</span>
              </b>
            </div>
            <div style={{ right: '0px', position: 'absolute', marginRight: '30px', top: '80px' }}>
              {selectedChild.child.siblings.map((item) => (
                <div key={item.childId}>
                  <span>{getFullName(item.name)}</span>
                  <span>[{item.childCode}]</span>
                </div>
              ))}
            </div>
            <div>
              <span style={{ fontSize: '18px' }}>
                <b>Letter: </b>
              </span>
              {selectedChild.name}
            </div>
            <div>
              <span style={{ fontSize: '18px' }}>
                <b>Send To: </b>
              </span>
              {selectedChild.recipients &&
                selectedChild.recipients.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '5px',
                      maxWidth: '300px',
                    }}
                  >
                    <span style={{ fontSize: '15px' }}>{item.recipientType.name}</span>
                    <Switch checked={switchStates[index]} onChange={(checked) => handleChange(checked, index)} />
                  </div>
                ))}
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default MessageModal;
